/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'qg65PaM45ytJDWNVfryxSK.png': { uri: '/images/qg65PaM45ytJDWNVfryxSK.png' },
'gALy8teQwqLSCynfucLGGH.png': { uri: '/images/gALy8teQwqLSCynfucLGGH.png' },
'p6dGcCWS259GxKzQk1r3pu.png': { uri: '/images/p6dGcCWS259GxKzQk1r3pu.png' },
'vXE8oPBv6YMiRpCmMgBeRt.png': { uri: '/images/vXE8oPBv6YMiRpCmMgBeRt.png' },
'dNPqgKDApio3jMsTWbx3YX.png': { uri: '/images/dNPqgKDApio3jMsTWbx3YX.png' },
'vJerLs6f53LYtsrPa4ff4d.png': { uri: '/images/vJerLs6f53LYtsrPa4ff4d.png' },
'6b2HjCsSLsS8oeazEQkxqw.png': { uri: '/images/6b2HjCsSLsS8oeazEQkxqw.png' },
'uFjpWFJ6VpHrUqDtnywaVS.png': { uri: '/images/uFjpWFJ6VpHrUqDtnywaVS.png' },
'eZAFiK3z5ppr3QEyKmGECb.png': { uri: '/images/eZAFiK3z5ppr3QEyKmGECb.png' },
'wBAmYN4APPiGSLZFKXjhwe.png': { uri: '/images/wBAmYN4APPiGSLZFKXjhwe.png' },
'st2abq3WGQsuRi6LwJajHq.png': { uri: '/images/st2abq3WGQsuRi6LwJajHq.png' },
'gMhZMsFcf9UiC9ZNgc2XDJ.png': { uri: '/images/gMhZMsFcf9UiC9ZNgc2XDJ.png' },
'sq15jvbG4VmvvuNPVeK1RX.png': { uri: '/images/sq15jvbG4VmvvuNPVeK1RX.png' },
'tFDyEEtUXyLAD71rHrAK7j.png': { uri: '/images/tFDyEEtUXyLAD71rHrAK7j.png' },
'jHeNsLpQQAzStLu62Bwtqc.png': { uri: '/images/jHeNsLpQQAzStLu62Bwtqc.png' },
'hHwCBv4L9Jx8RqmbVjbte6.png': { uri: '/images/hHwCBv4L9Jx8RqmbVjbte6.png' },
'agB4m8XuPZoRtsPta87Zuj.png': { uri: '/images/agB4m8XuPZoRtsPta87Zuj.png' },
'iYsuKdJHXe6hTwtdQNVhez.png': { uri: '/images/iYsuKdJHXe6hTwtdQNVhez.png' },
'feamyXTPc2k5ViBsXkGbQd.png': { uri: '/images/feamyXTPc2k5ViBsXkGbQd.png' },
'mkf7Y8zNTrFzYpiHxNSD17.png': { uri: '/images/mkf7Y8zNTrFzYpiHxNSD17.png' },
'tQLgeUYJSJK269Z39Pn8QF.png': { uri: '/images/tQLgeUYJSJK269Z39Pn8QF.png' },
'3GujtBsmZx1NEkFFbBLpKi.png': { uri: '/images/3GujtBsmZx1NEkFFbBLpKi.png' },
'8ERuXw5ps1LugQUAVfo6XN.png': { uri: '/images/8ERuXw5ps1LugQUAVfo6XN.png' },
'n3nDRMtYkLcn9tPN8zTTu6.png': { uri: '/images/n3nDRMtYkLcn9tPN8zTTu6.png' },
'gWYVdqMnP5SoXoBAKXj4QF.png': { uri: '/images/gWYVdqMnP5SoXoBAKXj4QF.png' },
'cESWDU7JtSS3ZFBqxCaLyj.png': { uri: '/images/cESWDU7JtSS3ZFBqxCaLyj.png' },
'qiDvdwj5LnomN85hKnQjy9.png': { uri: '/images/qiDvdwj5LnomN85hKnQjy9.png' },
'pMXx1Dfq8oycVRP1dyLTS7.png': { uri: '/images/pMXx1Dfq8oycVRP1dyLTS7.png' },
'6hVh2Q8ZtYodWWUcFWivHn.png': { uri: '/images/6hVh2Q8ZtYodWWUcFWivHn.png' },
'nawtXd4T4J5y7h57Li1daa.png': { uri: '/images/nawtXd4T4J5y7h57Li1daa.png' },
'7hkkzAGdm9c44oew2WE7JG.png': { uri: '/images/7hkkzAGdm9c44oew2WE7JG.png' },
'nYJk1N99PdX97yR9YKx1T8.png': { uri: '/images/nYJk1N99PdX97yR9YKx1T8.png' },
'7rHPejZAUAkXrcL5iGRXFX.png': { uri: '/images/7rHPejZAUAkXrcL5iGRXFX.png' },
'vXD6PCs5GgCwB9VH1MJ5kG.png': { uri: '/images/vXD6PCs5GgCwB9VH1MJ5kG.png' },
'cGGdL5MJq1XhBaoKyRgj3M.png': { uri: '/images/cGGdL5MJq1XhBaoKyRgj3M.png' },
'k3ojQT2CZjE5xzcxyN5t7L.png': { uri: '/images/k3ojQT2CZjE5xzcxyN5t7L.png' },
'pWRzXKBp4wUvBmwhZ9tPy5.png': { uri: '/images/pWRzXKBp4wUvBmwhZ9tPy5.png' },
'kC1jWcQcnkujvk4TEtvQio.png': { uri: '/images/kC1jWcQcnkujvk4TEtvQio.png' },
'oixRiYLAKfZoU3uQcb7t2J.png': { uri: '/images/oixRiYLAKfZoU3uQcb7t2J.png' },
'po4oE3XmpZcYd8F19VREdR.png': { uri: '/images/po4oE3XmpZcYd8F19VREdR.png' },
'4xWcEVYmpAya5ijYBDmRVD.png': { uri: '/images/4xWcEVYmpAya5ijYBDmRVD.png' },
'qxbYiUNWTHW6UQShZeWsB7.png': { uri: '/images/qxbYiUNWTHW6UQShZeWsB7.png' },
'qfaeNjFFU5FcAuwSfVJYuc.png': { uri: '/images/qfaeNjFFU5FcAuwSfVJYuc.png' }
}

export default imageStaticSourcesByFileName
